import React, { useState, useEffect } from "react";
import { useIntl, FormattedMessage } from 'react-intl'
import {
	Collapse,
	TextField,
	Grid,
	Box,
} from '@material-ui/core';
import Switch from "react-switch";

const FILTER_STATE_INIT = {
	titulo: '',
	version: '',
	showInactivos: false
}

const PoliticasPrivacidadGridFiltros = (props) => {
	const intl = useIntl();
	const [init, setInit] = useState(false)
	const [filtersLoading, setFiltersLoading] = useState(false)
	const [filtersState, setFiltersState] = useState(FILTER_STATE_INIT)

	useEffect(() => {
		if (props.filterResetInputs) {
			setFiltersState(FILTER_STATE_INIT);
		}
	}, [props.filterResetInputs])

	useEffect(() => {
		!props.dropdownActive && props.setFilterResetInputs(false)
		!props.dropdownActive && setFiltersLoading(false)
	}, [props.dropdownActive]);

	const handleChange = (name, value) => {
		props.handleFilterChange();
		setFiltersLoading(true);
		let query = JSON.parse(JSON.stringify(filtersState));

		if (query['titulo'] !== '') {
			props.setSearchActive(true);
		} else {
			props.setSearchActive(false);
		}

		query[name] = value;
		setInit(true);
		props.setFilterQuery(query);
		setFiltersLoading(false);
	};

	const handleChangeInactivosSwitch = (value) => {
		setFiltersState({ ...filtersState, showInactivos: value });
	};

	useEffect(() => {
		handleChange('showInactivos', filtersState.showInactivos);
	}, [filtersState.showInactivos])

	const handleOnEnter = (e, name, value) => {
		if (e.keyCode === 13) {
			e.preventDefault();
			handleChange(name, value);
		}
	};

	return (
		<>
			{init &&
				<Collapse in={props.dropdownActive}>
					<Grid container item xs={12} spacing={3} style={{ marginBottom: 20 }}>
						<Grid component={Box} item xs={3}>
							<form noValidate autoComplete="off">
								<TextField
									label={intl.formatMessage({ id: "politicasPrivacidad.titulo_campo", defaultMessage: "Título" })}
									placeholder={intl.formatMessage({ id: "politicasPrivacidad.titulo_campo", defaultMessage: "Título" })}
									name="titulo"
									value={filtersState.titulo}
									onChange={(e) => setFiltersState({ ...filtersState, titulo: e.target.value })}
									onKeyDown={(e) => handleOnEnter(e, 'titulo', filtersState.titulo)}
									onBlur={(e) => handleChange("titulo", filtersState.titulo)}
									disabled={filtersLoading}
									className="col-12"
								/>
							</form>
						</Grid>
						<Grid component={Box} item xs={3}>
							<form noValidate autoComplete="off">
								<TextField
									label={intl.formatMessage({ id: "politicasPrivacidad.version", defaultMessage: "Versión" })}
									placeholder={intl.formatMessage({ id: "politicasPrivacidad.version", defaultMessage: "Versión" })}
									name="version"
									value={filtersState.version}
									onChange={(e) => setFiltersState({ ...filtersState, version: e.target.value })}
									onKeyDown={(e) => handleOnEnter(e, 'version', filtersState.version)}
									onBlur={(e) => handleChange("version", filtersState.version)}
									disabled={filtersLoading}
									className="col-12"
								/>
							</form>
						</Grid>
						<Grid component={Box} item xs={3} className="align-self-end">
							<form noValidate autoComplete="off">
								<div className="d-flex inline justify-content-around align-items-center">
									<FormattedMessage
										id="formulariosGridFilters.render.filtros.ver_inactivos"
										defaultMessage="Ver Inactivos"
									/>
									<Switch
										onChange={(value) => handleChangeInactivosSwitch(value)}
										checked={filtersState.showInactivos}
										disabled={filtersLoading}
										offColor="#FF4961"
										onColor="#28D094"
									/>
								</div>
							</form>
						</Grid>
					</Grid>
				</Collapse>
			}
		</>
	)
}

export default PoliticasPrivacidadGridFiltros
